const paramsSerializer = (params: any) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    if (Array.isArray(val)) {
      val.forEach((elem: any) => searchParams.append(key, elem));
    } else if (val !== null && val !== undefined && val !== '') {
      searchParams.append(key, String(val)); // NOSONAR:S6551 - Generic serializer, objects not expected in practice
    }
  });
  return searchParams.toString();
};

export default paramsSerializer;
